export default class AccessibilitySiteTheme {
    constructor() {
        this.storageKeyTheme = 'theme-preference';
        this.theme = {
            value: this.getThemePrefence(),
        };

        this.html = document.querySelector('html');
        this.btnChangeSiteTheme = document.querySelectorAll('.theme .option');

        this.ready();

        this.changeSiteTheme();
    }

    ready() {
        if (this.btnChangeSiteTheme) {
            this.btnChangeSiteTheme.forEach((el) => {
                el.addEventListener('click', () => {
                    el.classList.add('active');
                    el.checked = true;
                    this.theme.value = el.dataset.theme;
                    this.setPreference();
                });
            });
        }
    }

    changeSiteTheme() {
        this.html.setAttribute('data-theme', this.theme.value);
        if (
            localStorage.getItem(this.storageKeyTheme) == 'default' ||
            localStorage.getItem(this.storageKeyTheme) == null
        ) {
            this.html.classList.remove('dark');
        } else {
            this.html.classList.add('dark');
        }

        this.btnChangeSiteTheme.forEach(option => {
            if(this.theme.value == 'dark' && option.value == 'ligado') {
                option.checked = true;
            }
        })
    }

    setPreference() {
        localStorage.setItem(this.storageKeyTheme, this.theme.value);
        this.changeSiteTheme();
    }

    getThemePrefence() {
        if (localStorage.getItem(this.storageKeyTheme) && localStorage.getItem(this.storageKeyTheme) != 'default') {
            return localStorage.getItem(this.storageKeyTheme);
        } else {
            return 'default';
        }
    }
}
new AccessibilitySiteTheme();
